import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserAlt } from '@fortawesome/pro-solid-svg-icons/faUserAlt';

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { defineMessages, FormattedMessage } from 'react-intl';

import { RadioCheckList } from 'ui-components/components/radio-check-list';
import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';
import { UserSettings } from '../../../enums/user-settings/user-settings';

import { getUserSettingsOptions } from '../../../services/settings/user-settings-service';

import style from './style.module.less';

const messages = defineMessages({
  showCustomerSummary: {
    description: 'Show Customer Summary in Popover',
    defaultMessage: 'Show on Hover',
    id: 'nZQ5xj',
  },
  hideCustomerSummary: {
    description: 'Hide Customer Summary in Popover',
    defaultMessage: 'Hide',
    id: 'Ly/SE6',
  },
  greyExternallyChangedOrders: {
    description: 'Continue to show externally changed orders/purchases in the grid with their content greyed out',
    defaultMessage: 'Gray out the order',
    id: 'Zy+B1E',
  },
  hideExternallyChangedOrders: {
    description: 'Hide externally changed orders/purchases in the grid',
    defaultMessage: 'Hide order from view',
    id: 'ccVAw2',
  },
});

const hideCustomerSummaryPopoverDisabled = getUserSettingsOptions(UserSettings.hideCustomerSummaryPopover);
const hideExternallyChangedOrdersOptions = getUserSettingsOptions(UserSettings.hideExternallyChangedOrders);

const hideCustomerPopover = (isSettingEnabled) => {
  return !isSettingEnabled ? messages.showCustomerSummary : messages.hideCustomerSummary;
};

const hideExternallyChangedOrdersLabel = (isSettingEnabled) => {
  return isSettingEnabled ? messages.hideExternallyChangedOrders : messages.greyExternallyChangedOrders;
};

const OrdersTab = ({
  userHasAdminOrConfigRole,
  hideCustomerSummaryPopover,
  setHideCustomerSummaryPopover,
  hideExternallyChangedOrdersSetting = false,
  setHideExternallyChangedOrdersSetting,
}) => {
  return (
    <div className={style['tab-content']}>
      <div className={classnames(style.section, style['non-header-buffer'])}>
        <div className={style.settings}>
          <label>
            <FontAwesomeIcon className={style['key-icon']} icon={faUserAlt} />
            <FormattedMessage {...UserSettings.hideCustomerSummaryPopover.messageDescriptor} />
          </label>
          <div className={style['setting-options']}>
            <RadioCheckList className={style['radio-checklist']}>
              {hideCustomerSummaryPopoverDisabled.map((option) => (
                <RadioCheckListItem
                  key={option.settingValue}
                  isChecked={option.settingValue === hideCustomerSummaryPopover}
                  isDisabled={!userHasAdminOrConfigRole}
                  onChecked={() => setHideCustomerSummaryPopover(option.settingValue)}
                >
                  <FormattedMessage {...hideCustomerPopover(option.settingValue)} />
                </RadioCheckListItem>
              ))}
            </RadioCheckList>
          </div>
          <label>
            <FontAwesomeIcon className={style['key-icon']} icon={faUserAlt} />
            <FormattedMessage {...UserSettings.hideExternallyChangedOrders.messageDescriptor} />
          </label>
          <div className={style['setting-options']}>
            <RadioCheckList className={style['radio-checklist']}>
              {hideExternallyChangedOrdersOptions.map((option) => (
                <RadioCheckListItem
                  key={option.settingValue}
                  isChecked={option.settingValue === hideExternallyChangedOrdersSetting}
                  isDisabled={!userHasAdminOrConfigRole}
                  onChecked={() => setHideExternallyChangedOrdersSetting(option.settingValue)}
                >
                  <FormattedMessage {...hideExternallyChangedOrdersLabel(option.settingValue)} />
                </RadioCheckListItem>
              ))}
            </RadioCheckList>
          </div>
        </div>
      </div>
    </div>
  );
};

OrdersTab.propTypes = {
  userHasAdminOrConfigRole: PropTypes.bool.isRequired,
  hideCustomerSummaryPopover: PropTypes.bool.isRequired,
  setHideCustomerSummaryPopover: PropTypes.func.isRequired,
  hideExternallyChangedOrdersSetting: PropTypes.bool,
  setHideExternallyChangedOrdersSetting: PropTypes.func.isRequired,
};

export default OrdersTab;
